import { Voni } from '../client';

export interface ContactFormRequest {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export interface DemoScheduleRequest {
  name: string;
  email: string;
  company?: string;
  phone?: string;
  preferred_date?: string;
  preferred_time?: string;
  message?: string;
}

export class ContactResource {
  constructor(private client: Voni) {}

  async submit(data: ContactFormRequest): Promise<{ status: string }> {
    return this.client.request<{ status: string }>('POST', '/contact/submit', undefined, data);
  }

  async scheduleDemo(data: DemoScheduleRequest): Promise<{ status: string }> {
    return this.client.request<{ status: string }>('POST', '/contact/schedule-demo', undefined, data);
  }
}
